import React, { useState, useRef, useEffect } from 'react';
import { Dropdown, Menu, Modal, Spin, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { openShareModal, openCreatePadDrawer, openVersionModal } from '../../../app/EditorSlice';
import {
    PlusOutlined,
    FolderOpenOutlined,
    ShareAltOutlined,
    EditOutlined,
    HistoryOutlined,
    InfoCircleOutlined,
    FileTextOutlined,
    PrinterOutlined,
    RightOutlined,
} from '@ant-design/icons';
import ImportMenu from '../../ImportExport/import';
import ExportMenu from '../../ImportExport/export';
import usePrint from '../../Print/usePrint';
import { LoadingOutlined } from '@ant-design/icons';
import './style.css';
import { workwiseServices } from '../../../api';
import RenameModal from '../../DocumentTitle/RenameModal';

const FileMenu = ({
    selectedExportType,
    setSelectedExportType,
}) => {
    const dispatch = useDispatch();
    const documentInformation = useSelector((state) => state.editor.documentInformation);
    const isTemplateDocument = useSelector((state) => state.editor.isTemplateDocument);
    const isReadOnly = useSelector((state) => state.editor.isReadOnly);
    const userInformation = useSelector((state) => state.editor.userInformation);
    const [fileMenuVisible, setFileMenuVisible] = useState(false);
    const importMenuRef = useRef(null);
    const [isExportModalVisible, setIsExportModalVisible] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [renameModalVisible, setRenameModalVisible] = useState(false);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const { isGeneratingPreview, handlePrint } = usePrint();

    const handleMenuClick = ({ key }) => {
        // keep import menu open until we explicitly close it from ImportMenu (so file input click can open)
        if (key === 'import') {
            if (importMenuRef.current && typeof importMenuRef.current.openFileDialog === 'function') {
                importMenuRef.current.openFileDialog();
            }
            return;
        }
        if (key === 'new') {
            dispatch(openCreatePadDrawer(null));
            setFileMenuVisible(false);
            return;
        }
        if (key === 'share') {
            dispatch(openShareModal());
            setFileMenuVisible(false);
            return;
        }
        if (key === 'rename') {
            setRenameModalVisible(true);
            setFileMenuVisible(false);
            return;
        }
          if (key === 'version-history') {
            dispatch(openVersionModal());
            setFileMenuVisible(false);
            return;
        }
        if (key === 'print') {
            // trigger print via the shared hook
            handlePrint();
            setFileMenuVisible(false);
        }
    };   

    const fileMenu = (
        <Menu onClick={handleMenuClick} className="file-menu">
            {/* Primary actions */}
            <Menu.Item key="new">
                <span className="file-menu-item">
                    <span className="file-menu-item-left"><PlusOutlined /></span>
                    <span className="file-menu-item-text">New</span>
                </span>
            </Menu.Item>
            {/* <Menu.Item key="open">
                <span className="file-menu-item">
                    <span className="file-menu-item-left"><FolderOpenOutlined /></span>
                    <span className="file-menu-item-text">Open</span>
                </span>
            </Menu.Item> */}
            {/* <Menu.Item key="make-copy">
                <span className="file-menu-item">
                    <span className="file-menu-item-left"><CopyOutlined /></span>
                    <span className="file-menu-item-text">Make a copy</span>
                </span>
            </Menu.Item> */}

            <Menu.Divider />

            {/* Collaboration */}
            {!isReadOnly && documentInformation.createBy == userInformation.userId && !isTemplateDocument && (
                <Menu.Item key="share">
                    <span className="file-menu-item">
                        <span className="file-menu-item-left"><ShareAltOutlined /></span>
                        <span className="file-menu-item-text">Share</span>
                    </span>
                </Menu.Item>
            )}
            {/* <Menu.SubMenu key="email" title={<span className="file-menu-item"><span className="file-menu-item-left"><MailOutlined /></span><span className="file-menu-item-text">Email</span><span className="file-menu-item-arrow"><RightOutlined /></span></span>} popupClassName="file-menu-submenu">
                <Menu.Item key="email:as-attachment">
                    <span className="file-menu-item">
                        <span className="file-menu-item-left" />
                        <span className="file-menu-item-text">Email as attachment</span>
                    </span>
                </Menu.Item>
            </Menu.SubMenu> */}

            <Menu.Divider />

            {/* File operations */}
            {!isReadOnly && (
                <Menu.Item key="rename">
                    <span className="file-menu-item">
                        <span className="file-menu-item-left"><EditOutlined /></span>
                        <span className="file-menu-item-text">Rename</span>
                    </span>
                </Menu.Item>
            )}
            {/* <Menu.Item key="move">
                <span className="file-menu-item">
                    <span className="file-menu-item-left"><FolderAddOutlined /></span>
                    <span className="file-menu-item-text">Move</span>
                </span>
            </Menu.Item>
            <Menu.Item key="add-shortcut">
                <span className="file-menu-item">
                    <span className="file-menu-item-left"><LinkOutlined /></span>
                    <span className="file-menu-item-text">Add shortcut to Drive</span>
                </span>
            </Menu.Item>
            <Menu.Item key="move-to-trash">
                <span className="file-menu-item">
                    <span className="file-menu-item-left"><DeleteOutlined /></span>
                    <span className="file-menu-item-text">Move to trash</span>
                </span>
            </Menu.Item> */}

            <Menu.Divider />

            {!isReadOnly && !isTemplateDocument && (
                <Menu.Item key="version-history">
                    <span className="file-menu-item">
                        <span className="file-menu-item-left"><HistoryOutlined /></span>
                        <span className="file-menu-item-text">Version history</span>
                    </span>
                </Menu.Item>
            )}
            {/* <Menu.Item key="offline">
                <span className="file-menu-item">
                    <span className="file-menu-item-left"><FileTextOutlined /></span>
                    <span className="file-menu-item-text">Make available offline</span>
                </span>
            </Menu.Item> */}

            <Menu.Divider />

            {/* <Menu.Item key="details">
                <span className="file-menu-item">
                    <span className="file-menu-item-left"><InfoCircleOutlined /></span>
                    <span className="file-menu-item-text">Details</span>
                </span>
            </Menu.Item> */}
            {/* <Menu.Item key="security">
                <span className="file-menu-item">
                    <span className="file-menu-item-left"><LockOutlined /></span>
                    <span className="file-menu-item-text">Security limitations</span>
                </span>
            </Menu.Item> */}

            {/* <Menu.Divider /> */}

            {/* <Menu.SubMenu key="language" title={<span className="file-menu-item"><span className="file-menu-item-left"><GlobalOutlined /></span><span className="file-menu-item-text">Language</span><span className="file-menu-item-arrow"><RightOutlined /></span></span>} popupClassName="file-menu-submenu">
                <Menu.Item key="language:en">
                    <span className="file-menu-item">
                        <span className="file-menu-item-left" />
                        <span className="file-menu-item-text">English</span>
                    </span>
                </Menu.Item>
                <Menu.Item key="language:es">
                    <span className="file-menu-item">
                        <span className="file-menu-item-left" />
                        <span className="file-menu-item-text">Spanish</span>
                    </span>
                </Menu.Item>
            </Menu.SubMenu> */}
            {/* <Menu.Item key="page-setup">
                <span className="file-menu-item">
                    <span className="file-menu-item-left"><FileTextOutlined /></span>
                    <span className="file-menu-item-text">Page setup</span>
                </span>
            </Menu.Item> */}
            <Menu.Item key="print">
                <span className="file-menu-item">
                    <span className="file-menu-item-left"><PrinterOutlined /></span>
                    <span className="file-menu-item-text">Print</span>
                </span>
            </Menu.Item>
            <Menu.Divider />

            {/* Import / Export integration */}
            <Menu.Item key="import">
                <span className="file-menu-item">
                    <span className="file-menu-item-left"><FolderOpenOutlined /></span>
                    <span className="file-menu-item-text"><ImportMenu ref={importMenuRef} setFileMenuVisible={setFileMenuVisible} /></span>
                </span>
            </Menu.Item>
            <Menu.SubMenu key="export" title={<span className="file-menu-item"><span className="file-menu-item-left"><FileTextOutlined /></span><span className="file-menu-item-text">Export</span><span className="file-menu-item-arrow"><RightOutlined /></span></span>} onTitleClick={() => setFileMenuVisible(true)} popupClassName="file-menu-submenu">
                <ExportMenu
                    setFileMenuVisible={setFileMenuVisible}
                    isExportModalVisible={isExportModalVisible}
                    setIsExportModalVisible={setIsExportModalVisible}
                    selectedExportType={selectedExportType}
                    setSelectedExportType={setSelectedExportType}
                />
            </Menu.SubMenu>
        </Menu>
    );

    return (
        <>
            <Dropdown
                overlay={fileMenu}
                trigger={['click']}
                visible={fileMenuVisible}
                onVisibleChange={(visible) => setFileMenuVisible(visible)}
                placement={isMobile ? "rightTop" : undefined}
            >
                <div
                    className="navTabItem file-menu-dropdown-title"
                    role="menuitem"
                    tabIndex={0}
                    onMouseDown={e => e.preventDefault()} /* prevent focus stealing while allowing keyboard navigation */
                >
                    <span className="nav-tab-trigger">
                        <span className="nav-tab-icon"><FileTextOutlined /></span>
                        <span className="nav-tab-label">File</span>
                        <span className="nav-tab-arrow"><RightOutlined /></span>
                    </span>
                </div>
            </Dropdown>
            <RenameModal
                visible={renameModalVisible}
                onClose={() => setRenameModalVisible(false)}
            />
            <Modal
                title="Generating preview"
                visible={isGeneratingPreview}
                closable={false}
                footer={null}
                width={240}
                zIndex={9999}
                centered
                style={{ borderRadius: '8px', width: '150px' }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <p style={{ marginBottom: '10px' }}>This may take a few moments</p>
                    <Spin
                        indicator={
                            <LoadingOutlined
                                style={{
                                    fontSize: 28,
                                    fontWeight: 'bold',
                                    color: 'black'
                                }}
                                spin
                            />
                        }
                    />
                </div>
            </Modal>
        </>
    );
};

export default FileMenu;